import React from "react";
import { WEB_PAYMENT_SEARCH_TYPE } from "../../../../constants/picker-entries-constants";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import ET3Radio from "../../../../core/et3-input/et3-radio";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import getWebPayments from "../../../../stores/auditor-store/web-payments";
import { TWebPaymentsSearchOptions } from "../../../../Types";
import SearchByDateOrUser from "./SearchByDateOrUser";

const WebPaymentsForm = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { unitX } = theme;
  const webPaymentChoiceValue = getWebPayments().webPaymentChoiceValue.get();

  return (
    <React.Fragment>
      <ET3Radio
        options={WEB_PAYMENT_SEARCH_TYPE}
        value={webPaymentChoiceValue}
        onChoose={(value: TWebPaymentsSearchOptions) => {
          getWebPayments().setWebPaymentChoice(value);
        }}
        style={{
          width: 850 * unitX
        }}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <SearchByDateOrUser />
    </React.Fragment>
  );
});
export default WebPaymentsForm;
